import { render, staticRenderFns } from "./RemoveAllPage.vue?vue&type=template&id=6b3713a0&scoped=true"
import script from "./RemoveAllPage.vue?vue&type=script&lang=js"
export * from "./RemoveAllPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3713a0",
  null
  
)

export default component.exports